export default "__VITE_ASSET__119dd84c__"